import _ from 'underscore';
import Backbone from 'backbone';

/**
 * The class used to communicate differente components
 * @memberof core.widget.widgetHelpers
 */
class EventBus {
  /**
   * Gets an event bus instance
   * @type {core.widget.widgetHelpers.EventBus}
   */
  get bus() {
    if (!_.isObject(this._bus)) {
      this._bus = _.extend({}, Backbone.Events);
    }
    return this._bus;
  }
}

export default EventBus;



// WEBPACK FOOTER //
// ./lmm-widget/src/widget/widgetHelpers/EventBus.js